import { Modal } from 'antd'
import React from 'react'
import { ClockCircleOutlined, StopOutlined } from '@ant-design/icons'
import { history } from '../_history'
import UniversalError from '../UniversalError/UniversalError'

const handle422 = (error, api) => {
	api.logout()
}

const handle401 = (error, api) => {
	const { config } = error
	const originalRequest = config
	if (~error.response.config.url.indexOf('login')) {
		return Promise.reject(error)
	}
	if (~error.response.config.url.indexOf('refresh')) {
		api.logout()
		return
	}
	api.refreshToken()

	return new Promise((resolve) => {
		api.addSubscriber((access_token) => {
			originalRequest.headers.Authorization = `Bearer ${access_token}`
			resolve(api.service(originalRequest))
		})
	})
}

const handle0 = () => {
	Modal.error({
		content: <UniversalError code={0} />,
		icon: null,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

const handle402 = () => {
	Modal.error({
		content: <UniversalError code={402} />,
		icon: <StopOutlined />,
		title: 'NO SUBSCRIPTION',
		width: '500px',
		centered: true,
		onOk() {
			// history.push('/')
		},
	})
}

const handle404 = () => {
	Modal.error({
		content: <UniversalError code={404} />,
		icon: <ClockCircleOutlined />,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

const handle332 = () => {
	Modal.error({
		content: <UniversalError code={332} />,
		icon: <StopOutlined />,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

const handle331 = () => {
	Modal.error({
		content: <UniversalError code={331} />,
		icon: <StopOutlined />,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}
const handle330 = () => {
	Modal.error({
		content: <UniversalError code={330} />,
		icon: <StopOutlined />,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

const handle429 = () => {
	Modal.error({
		content: <UniversalError code={429} />,
		icon: <ClockCircleOutlined />,
		title: 'TOO MANY REQUESTS',
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

const handle500 = () => {
	// ReactDOM.render(
	// 	<div
	// 		style={{
	// 			position: 'absolute',
	// 			top: 0,
	// 			left: 0,
	// 			zIndex: 100,
	// 			width: '100%',
	// 			height: '100%',
	// 			fontSize: '20px',
	// 			color: 'white',
	// 			backgroundColor: 'lightblue',
	// 			display: 'flex',
	// 			alignItems: 'center',
	// 			justifyContent: 'center',
	// 		}}
	// 	>
	// 		test
	// 		{/* <EmptyData */}
	// 		{/* 	text={'Oops, something gone wrong!'} */}
	// 		{/* 	addedText={"Don't worry! Try to reload app."} */}
	// 		{/* 	isErrorHandler */}
	// 		{/* 	// refreshPage={resetError} */}
	// 		{/* /> */}
	// 	</div>,
	// 	document.querySelector('#error')
	// )

	Modal.error({
		content: <UniversalError code={500} />,
		icon: null,
		width: '500px',
		centered: true,
		onOk() {
			history.push('/')
		},
	})
}

function handleSuccess(response) {
	return response
}

function handleError(error) {
	switch (error.response.status) {
		// let ui handle this code status
		case 0:
			return handle0(error)
		case 400:
			break
		case 401:
			return handle401(error, this)
		case 422:
			return handle422(error, this)
		case 402:
			handle402(error)
			break
		case 404:
			handle404(error)
			break
		case 331:
			handle331(error)
			break
		case 330:
			handle330(error)
			break
		case 332:
			handle332(error)
			break
		case 418:
			// handle418(error)
			break
		case 419:
			break
		case 429:
			handle429(error)
			break
		default:
			handle500(error)
			break
	}

	return Promise.reject(error)
}

export { handleSuccess, handleError }
